import React from 'react';

type Props = {
  children?: any;
  className?: string;
  container?: boolean;
  style?: any;
  /** Container Props **/
  flexDirection?: 'row' | 'column';
  justifyContent?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly' | 'initial' | 'inherit';
  flexWrap?: 'wrap' | 'nowrap' | 'wrap-reverse';
  alignItems?: 'stretch' | 'center' | 'flex-start' | 'flex-end' | 'baseline' | 'initial' | 'inherit';
  /** Child Props **/
  flexGrow?: number;
  flexShrink?: number;
  flexBasis?: number;
  flex?: string;
  /** Common Layout Props **/
  padding?: string;
  margin?: string;
  width?: string;
  height?: string;
  maxWidth?: string;
  maxHeight?: string;
  gap?: number;
  tabIndex?: number;
  ariaLabel?: string;
};

const Flex = (props: Props) => {
  return (
    <div
      aria-label={props.ariaLabel}
      tabIndex={props.tabIndex}
      className={props.className}
      style={{
        display: props.container ? 'flex' : 'block',
        justifyContent: props.justifyContent || 'flex-start',
        flexDirection: props.flexDirection || 'row',
        flexGrow: props.flexGrow || 0,
        flexBasis: props.flexBasis || 'auto',
        flexShrink: props.flexShrink || 1,
        flexWrap: props.flexWrap || 'nowrap',
        flex: props.flex || '0 1 auto',
        alignItems: props.alignItems || 'stretch',
        gap: props.gap,
        ...props.style,
      }}
    >
      {props.children}
    </div>
  );
};

export default Flex;
